const authModes = Object.freeze({
  Local: '1',
  ActiveDirectory: '2',
  Sie: '3',
});

export const authModeOptions = [
  { label: 'Local', value: authModes.Local },
  { label: 'Active Directory', value: authModes.ActiveDirectory },
  { label: 'SIE', value: authModes.Sie },
];

export default authModes;
